var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlutter(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40516"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 3407",
    style: {
      fill: "none"
    },
    d: "M0 0h45v45H0z"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 40516"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47251",
    d: "m-124.154 481.195-18.178-18.007-6.512 6.552 11.466 11.455z",
    transform: "translate(163.781 -437.339)",
    style: {
      isolation: "isolate",
      fill: "#0d47a1"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47252",
    d: "M-127.131 430.9h-13.086l-21.541 21.428 6.462 6.5z",
    transform: "translate(166.758 -429.896)",
    style: {
      fill: "#67b7f7",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47253",
    d: "M-124.154 456.621h-13.156l-11.535 11.6 6.5 6.494z",
    transform: "translate(163.781 -435.826)",
    style: {
      fill: "#67b7f7",
      isolation: "isolate"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 47254",
    d: "m-135.763 469.692-6.581 6.542-6.5-6.5 6.518-6.548z",
    transform: "translate(163.781 -437.34)",
    style: {
      opacity: 0.22,
      isolation: "isolate",
      fill: "#0d47a1"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlutter);
export default __webpack_public_path__ + "static/media/Flutter.8fcb6832560dc8f164fdd071fa021819.svg";
export { ForwardRef as ReactComponent };